import styles from './styles.module.scss'

export function PersonalDetail({
  label,
  value
}: {
  label: string
  value: string | React.ReactNode
}) {
  return (
    <div className={styles.DetailsRow}>
      <p>
        <strong>{label}</strong>
      </p>
      <p>{value}</p>
    </div>
  )
}
